import ReactOnRails from 'react-on-rails';
import EventSubmissionApp from '../bundles/EventSubmission/startup/EventSubmissionApp';
import CheckoutApp from '../bundles/EventSubmission/startup/CheckoutApp';
import OneStepCheckout from '../bundles/EventSubmission/startup/OneStepCheckout';
import PublisherCheckout from '../bundles/EventSubmission/startup/PublisherCheckout';

ReactOnRails.register({
  EventSubmissionApp,
});

ReactOnRails.register({
  CheckoutApp,
});

ReactOnRails.register({
  OneStepCheckout
});

ReactOnRails.register({
  PublisherCheckout
});



// WEBPACK FOOTER //
// app/client/packs/event-submission-bundle.js